Shopify.accordion = function (headerClass) {
    document.querySelectorAll(headerClass).forEach(heading => {
        heading.addEventListener('click', (event) => {
            heading.parentNode.classList.toggle('active');
            for (const sibling of heading.parentNode.parentNode.children) {
                if (sibling !== heading.parentNode) {
                    sibling.classList.remove('active');
                }
            }
        });
    });
};
